import { AuthResponse } from '@models/Auth';
import { StorageManager } from '@storage/index';
import axios, { AxiosInstance, AxiosError, AxiosRequestConfig } from 'axios';
import { ROUTES } from 'src/config/routes';
import { STATUS_CODE, TIME_TO_REDIRECT } from 'src/utils/constants';

interface IAxiosConfig extends AxiosRequestConfig {
	retry?: boolean;
}

const storage = new StorageManager();
const localStorage = new StorageManager('local');

const redirect = (path: string) => setTimeout(() => (window.location.href = path), TIME_TO_REDIRECT);

export const tokenErrorLogout = () => {
	// getToast({ type: 'error', description: 'Sua sessão expirou, faça login novamente!' });
	storage.clean();
	redirect(ROUTES.login);
};

const apiClient: AxiosInstance = axios.create({
	baseURL: import.meta.env.VITE_API_BASE_URL,
	withCredentials: true,
	headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use(config => {
	const credentials = localStorage.getItem<AuthResponse>('credentials') ?? storage.getItem<AuthResponse>('credentials');

	if (credentials) {
		config.headers['Authorization'] = `Bearer ${credentials.accessToken}`;
	}

	return config;
});

axios.interceptors.response.use(
	response => response,
	async (error: AxiosError) => {
		const originalConfig = error.config as IAxiosConfig;

		if (error?.response?.status === STATUS_CODE.Unauthorized && !originalConfig.retry) {
			try {
				originalConfig.retry = true;
				// await refreshToken();
				await axios(originalConfig);
				//
			} catch (error) {
				tokenErrorLogout();
			}
		}

		return Promise.reject(error);
	},
);

export { apiClient };
